import api from './api'

export const uangPangkalService = {
  getAll: (params = {}) => api.get('/uang-pangkal', { params }),
  getByNBA: (nba) => api.get(`/uang-pangkal/${nba}`),
  bayar: (nba, data) => api.post(`/uang-pangkal/${nba}/bayar`, data),
  init: () => api.post('/uang-pangkal/init')
}
